import React, { PureComponent } from 'react';
import Spinner from 'shared/lib/components/Spinner';
import PropTypes from 'prop-types';
import './RentalCarExtensionStart.css';

const propTypes = {
  getRentalCarExtensionPolicy: PropTypes.func,
  redirect: PropTypes.func,
};

class RentalCarExtensionStart extends PureComponent {
  componentDidMount() {
    this.props.getRentalCarExtensionPolicy().then(policy => {
      const basePath = `/rental-car-insurance/extension/${
        this.props.policy.id
      }`;
      if (policy.rental_agreement_number) {
        this.props.redirect(`${basePath}/payment`);
      } else {
        this.props.redirect(`${basePath}/confirmation-number`);
      }
    });
  }

  render() {
    return (
      <div className="RentalCarExtensionStart Container Container--small">
        <Spinner />
      </div>
    );
  }
}

RentalCarExtensionStart.propTypes = propTypes;

export default RentalCarExtensionStart;
